<template>
  <div class="blog-container">
    <h2 class="blog-title">Blog Posts</h2>
    <Sidebar />
    <div v-if="loading" class="loading">
      Loading blog posts...
    </div>
    
    <div v-else-if="error" class="error">
      {{ error }}
    </div>
    
    <div v-else class="blog-posts">
      <div v-for="post in blogPosts" :key="post.id" class="blog-post">
        <img v-if="post.featured_image" :src="post.featured_image" :alt="post.title" class="featured-image">
        <h3>{{ post.title }}</h3>
        <p class="excerpt">{{ post.excerpt }}</p>
        <div class="post-meta">
          <span class="status">Status: {{ post.status }}</span>
          <span v-if="post.publish_date" class="date">Published: {{ formatDate(post.publish_date) }}</span>
        </div>
        <div class="content" v-html="post.content"></div>
      </div>
      
      <!-- Pagination -->
      <div class="pagination" v-if="pagination">
        <button 
          :disabled="!pagination.prev_page_url" 
          @click="fetchPosts(currentPage - 1)"
          class="pagination-btn"
        >
          Previous
        </button>
        <span class="page-info">Page {{ currentPage }} of {{ pagination.last_page }}</span>
        <button 
          :disabled="!pagination.next_page_url" 
          @click="fetchPosts(currentPage + 1)"
          class="pagination-btn"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Sidebar from './Sidebar.vue'
export default {
  name: 'BlogList',
  components: {
    Sidebar
  },
  data() {
    return {
      blogPosts: [],
      loading: true,
      error: null,
      currentPage: 1,
      pagination: null
    }
  },
  created() {
    this.fetchPosts()
  },
  methods: {
    async fetchPosts(page = 1) {
      this.loading = true
      this.error = null
      
      try {
        const response = await axios.get('http://127.0.0.1:8000/api/admin/content/blog', {
          headers: {
            'Authorization': 'Bearer 4772|9c59cECmt9uUr6o2UpP27l2VXjAP8tCdwpKoUYZ52e3047e5'
          },
          params: {
            page
          }
        })
        
        if (response.data.success) {
          this.blogPosts = response.data.data.data
          this.pagination = response.data.data
          this.currentPage = page
        } else {
          this.error = 'Failed to fetch blog posts'
        }
      } catch (err) {
        this.error = err.message || 'An error occurred while fetching blog posts'
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString()
    }
  }
}
</script>

<style scoped>
.blog-container {
  padding: 20px;
  max-width: 1200px;
  margin-left: 280px; /* Match sidebar width */
  margin: 0 20px 0 300px; /* Add margin from the left to account for sidebar */
  min-height: 100vh;
}

.blog-title {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #333;
}

.blog-posts {
  display: grid;
  gap: 2rem;
}

.blog-post {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.featured-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.excerpt {
  color: #666;
  margin: 1rem 0;
}

.post-meta {
  display: flex;
  gap: 1rem;
  color: #888;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
}

.pagination-btn {
  padding: 0.5rem 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.page-info {
  color: #666;
}

.loading, .error {
  text-align: center;
  padding: 2rem;
  color: #666;
}

.error {
  color: #dc3545;
}
</style> 